import { render } from "./BomEditor.vue?vue&type=template&id=68a8e2d4"
import script from "./BomEditor.vue?vue&type=script&lang=js"
export * from "./BomEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__